const settingsRoutes = [
    {
        path: '/settings',
        name: 'SettingsPage',
        component: () => import('../views/settings/SettingComponent.vue'),
        meta: {
            requiresAuth: true,
            roles: ['ADMIN'],
        },
    },
];

export default settingsRoutes;